import { Partner } from "@/lib/partners";
import { cn } from "@/ui/utils/cn";
import Image from "next/image";

/**
 * A partner developer's logo at a fixed height, or the partner's name when
 * no logo is on file. Logos are the partners' own marks (dark on light), so
 * callers put them on a white or mist tile.
 */
export const PartnerLogo = ({
  partner,
  lang,
  className,
}: {
  partner: Partner;
  lang: "en" | "ar";
  /** Sets the height (`h-6`, `h-8`, …); width follows the logo's ratio. */
  className?: string;
}) =>
  partner.logo ? (
    <Image
      src={partner.logo.src}
      alt={partner.name[lang]}
      width={partner.logo.width}
      height={partner.logo.height}
      unoptimized
      className={cn("h-6 w-auto", className)}
    />
  ) : (
    <span className={cn("text-[15px] font-semibold text-ink", className)}>
      {partner.name[lang]}
    </span>
  );
